export const getFilter = (filter) => {
  const resultFilter = {};

  Object.keys(filter).forEach((alias) => {
    if (alias === `parent` || alias === `name` || alias === `promo`) {
      resultFilter[alias] = filter[alias];
    } else if (filter[alias].type === `range`) {
      let results = [];

      if (filter[alias].min || filter[alias].max) {
        results.push(`${filter[alias].min}-${filter[alias].max}`);
      }

      results = results.concat(filter[alias].values.map((it) => it.id));

      resultFilter[alias] = results.join(`,`);
    } else {
      resultFilter[alias] = filter[alias].values.map((it) => it.id).join(`,`);
    }
  });

  return resultFilter;
};
